import APIConfiguration from '@savgroup-front-common/configuration/api';
import { COMMON_QUERY_PARAMS } from '@savgroup-front-common/constants';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared';
import {
  BackResponse,
  BackResponseFailure,
  FileAttachmentSummary,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { apiCall } from '../../services';

const ENDPOINT = `${APIConfiguration.workflow}files/${COMMON_QUERY_PARAMS.FILE_ID}/control-attachments-visible-for-customer`;

export interface ListFileAttachmentsFromControlQueryPayload {
  fileId: string;
}

export type ListFileAttachmentsFromControlQuery = (
  payload: ListFileAttachmentsFromControlQueryPayload,
) => Promise<BackResponse<FileAttachmentSummary[]> | BackResponseFailure>;

export const listFileAttachmentsFromControlQuery: ListFileAttachmentsFromControlQuery =
  async ({ fileId }) => {
    try {
      const url = ENDPOINT.replace(COMMON_QUERY_PARAMS.FILE_ID, fileId);

      return await apiCall<BackResponse<FileAttachmentSummary[]>>(url, {
        method: SUPPORTED_METHODS.GET,
      });
    } catch (exception) {
      return prepareResponseFailure(exception);
    }
  };
